// extracted by mini-css-extract-plugin
module.exports = {"cell":"table-row_cell__2zKh8","hideOnMobile":"table-row_hideOnMobile__3yX-q"};